import {DateRangeType} from "@shared-features/enums/shared-enums.enum";

export class DateRange {
  public range: DateRangeType | null;
  public startFrom: string | null;
  public endAt: string | null;
}
